import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvironmentService } from './environment.service';

@Injectable({ providedIn: 'root' })
export class FilterViewApiService {
    constructor(
        private httpClient: HttpClient,
        private environmentService: EnvironmentService
    ) {}

    private get url(): string {
        return `${this.environmentService.getCurrentApiUrl()}/filter-views`;
    }

    getFilterViews(entityType: string): Observable<any> {
        return this.httpClient.get<any>(`${this.url}?entityType=${entityType}`);
    }

    createFilterView(data: any): Observable<any> {
        return this.httpClient.post<any>(this.url, data);
    }

    updateFilterView(data: any): Observable<any> {
        return this.httpClient.put<any>(this.url, data);
    }

    pinFilterView(data: any): Observable<any> {
        return this.httpClient.put<any>(`${this.url}/pin`, data);
    }

    deleteFilterView(id: string): Observable<any> {
        return this.httpClient.delete<any>(`${this.url}/${id}`);
    }
}

